import axios from 'axios';
import { useContext } from 'react';
import useSWRMutation from 'swr/mutation';
import { TokenContext } from '../context/TokenContext';
import config from '../config';

// arg: { token: string, body: any }

export const afasPoster = async (path, { arg }) => {
  console.log({ arg });
  console.log('before destructuring');
  const { token, body } = arg;
  console.log('the body of the request');
  console.log({ body });
  return axios
    .post(`${config.BASE_URL_DEV}${path}`, body, {
      headers: {
        'Content-Type': 'application/json',
        Authorization: token,
      },
    })
    .then((res) => res.data);
};

function useAfasDataMutation(path) {
  const token = useContext(TokenContext);
  // eslint-disable-next-line no-unused-vars
  const { trigger, isMutating, error, data } = useSWRMutation(path ? path : null, afasPoster, {});

  function doTrigger(body) {
    return trigger({ token: token, body: body });
  }

  return {
    trigger: doTrigger,
    data,
    isMutating,
    error,
  };
}

export default useAfasDataMutation;
